<ng-container *transloco="let t">
    <!-- Breadcrumb -->
    <div class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-between">
        <h5 class="mb-0">
            {{t('companies-list')}}
        </h5>
        <ol class="breadcrumb list-unstyled mt-0 mb-0 pl-0">
            <li class="breadcrumb-item position-relative">
                {{t('Masters')}}
            </li>
            <li class="breadcrumb-item position-relative">
                {{t('Companies')}}
            </li>
            <li class="breadcrumb-item position-relative">
                {{t('companies-list')}}
            </li>
        </ol>
    </div>
    @if (isLoadingResults || isRateLimitReached) {
    <div class="loading-shade">
        @if (isLoadingResults) {
        <mat-spinner></mat-spinner>
        }
        @if (isRateLimitReached) {
        <div class="rate-limit-reached">
            ALTAIR rate limit has been reached. It will be reset in one minute.
        </div>
        }
    </div>
    }
    <!-- Companies -->
    <mat-card class="altair-card companies-card mb-25 border-radius bg-white border-none d-block"
        [class.rtl-enabled]="themeService.isRTLEnabled()">
        <mat-card-header>
            <mat-card-title>
                <form class="search-box position-relative">
                    <i class="material-symbols-outlined">
                        search
                    </i>
                    <input matInput class="input-search d-block w-100 border-none outline-0"
                        placeholder="{{t('search')}} {{t('company')}}..." (keyup)="applyFilter($event)"
                        (keydown.enter)="onKeydown($event)" #input>
                </form>
            </mat-card-title>
            <mat-card-subtitle>
                <a mat-button class="add-new-btn" routerLink="/masters/create-company">
                    + {{t('add-new-company')}}
                </a>
            </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
            <div class="companies-table">
                <div class="table-responsive">
                    <table mat-table [dataSource]="dataSource" matSort matSortActive="name" matSortDisableClear
                        matSortDirection="asc">

                        <!-- Name Column -->
                        <ng-container matColumnDef="name">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{t('name')}}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                {{row.name}}
                            </td>
                        </ng-container>

                        <!-- Identification Type Column -->
                        <ng-container matColumnDef="identificationType">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{t('identificationType')}}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                {{row.identificationType}}
                            </td>
                        </ng-container>

                        <!-- Identification Column -->
                        <ng-container matColumnDef="identification">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{t('identification')}}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                {{row.identification}}
                            </td>
                        </ng-container>

                        <!-- Address Column -->
                        <ng-container matColumnDef="address">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{t('address')}}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                {{row.address}}
                            </td>
                        </ng-container>

                        <!-- Start Contract Column -->
                        <ng-container matColumnDef="startContract">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{t('startContract')}}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                {{row.startContract.substring(0, 10)}}
                            </td>
                        </ng-container>

                        <!-- End Contract Column -->
                        <ng-container matColumnDef="endContract">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{t('endContract')}}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                {{row.endContract.substring(0, 10)}}
                            </td>
                        </ng-container>

                        <!-- Action Column -->
                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef>
                                {{t('action')}}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <div class="action-info">
                                    <a mat-button routerLink="/masters/edit-company/{{row.id}}"
                                        matTooltip="{{t('edit')}} {{t('company')}}" matTooltipPosition="above">
                                        <i class="material-symbols-outlined">
                                            edit
                                        </i>
                                    </a>
                                    <button type="button" mat-button (click)="delete(row.id)"
                                        matTooltip="{{t('delete')}} {{t('company')}}" matTooltipPosition="above">
                                        <i class="material-symbols-outlined">
                                            delete
                                        </i>
                                    </button>
                                </div>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                        <!-- Row shown when there is no matching data. -->
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="4">{{t('no-data-matching')}} "{{input.value}}"</td>
                        </tr>

                    </table>
                </div>
                <mat-paginator [length]="totalItems" [pageSizeOptions]="pageSizes" showFirstLastButtons></mat-paginator>
            </div>
        </mat-card-content>
    </mat-card>
</ng-container>
